import * as types from './types';

export const getCompanies = payload => ({
  type: types.COMPANIES_GET_REQUEST,
  payload,
});

export const updateOrCreateRequest = payload => ({
  type: types.COMPANIES_CREATE_OR_UPDATE_REQUEST,
  payload,
});

export const getByIdRequest = payload => ({
  type: types.COMPANIES_GET_BY_ID_REQUEST,
  payload,
});

export const resetCurrentItem = () => ({
  type: types.COMPANIES_GET_BY_ID_SUCCESS,
  payload: {
    title: '',
    tax_code: '',
    address: '',
    ateco_code: '',
  },
});

export const deleteCompany = payload => ({
  type: types.COMPANIES_DELETE_REQUEST,
  payload,
});

export const resetErrors = () => ({
  type: types.RESET_COMPANIES_ERRORS,
});
